import { httpPost } from "./httpService";

export function loginOrRegisterMapping() {
  return httpPost("/auth/v1/loginOrRegister", {});
}

export function fetchCurrentUser() {
  return httpPost("/auth/v1/currentUser", {});
}
